const topLit = [
    {
      "no": "m7MPJdpWVw8WID9k",
      "entrance": "关注的股票机会信号有更新，请查收~",
      "title": "发现你的自选/持仓股票机会信号有更新",
      "card": [
          {
              "sub": "增加“高成长”",
              "name": "瑞迈特（301367）机会类型：",
              "up": null,
              "upData": null,
              "url": {
                  "openSource": null,
                  "openType": "3",
                  "functionCode": "FN_Native_HangQing_StockDetail",
                  "param": {
                      "webUrl": null,
                      "loginType": null,
                      "jsCommands_onLoad": null,
                      "dzhStockType": "1",
                      "stockName": "瑞迈特",
                      "dzhStockCode": "301367"
                  }
              }
          },
          {
              "sub": "增加“WR金叉”",
              "name": "欧晶科技（001269）机会类型：",
              "up": null,
              "upData": null,
              "url": {
                  "openSource": null,
                  "openType": "3",
                  "functionCode": "FN_Native_HangQing_StockDetail",
                  "param": {
                      "webUrl": null,
                      "loginType": null,
                      "jsCommands_onLoad": null,
                      "dzhStockType": "1",
                      "stockName": "欧晶科技",
                      "dzhStockCode": "001269"
                  }
              }
          }
      ],
      "link": [
          "高成长信号瑞迈特策略回测",
          "WR金叉的股票有哪些"
      ],
      "push": "0",
      "type": "zxrb",
      "date": "20250825",
      "url": {
          "openSource": null,
          "openType": "3",
          "functionCode": "KDS_WebPageNoHead",
          "param": {
              "webUrl": "GYDJL://kds519/view/zxrb/home/zxrb.html",
              "loginType": "1",
              "jsCommands_onLoad": [
                  "setTableIndex(0)"
              ],
              "dzhStockType": null,
              "stockName": null,
              "dzhStockCode": null
          }
      },
      "linkUrl": null,
      "createTime": "1756082647685"
  },
  {
    "no": "0GQe5HPWhKtasgsO",
    "entrance": "检测到关注的股票风险等级有更新~",
    "title": "小元发现关注的个股风险等级较昨日提升：",
    "card": [
        {
            "sub": "提升至中风险",
            "name": "ST易事特（300376）风险等级",
            "up": null,
            "upData": null,
            "url": {
                "openSource": null,
                "openType": "4",
                "functionCode": "KDS_WebPageWithHead",
                "param": {
                    "webUrl": "http://guoyuan4.dengtacj.cn:55561/MineScanner/index.html#/pages/mineDimension/mineDimension?stockCode=0001300376&stockName=ST易事特",
                    "loginType": "1",
                    "jsCommands_onLoad": null
                }
            }
        },
        {
            "sub": "提升至高风险",
            "name": "汇金股份（300368）风险等级",
            "up": null,
            "upData": null,
            "url": {
                "openSource": null,
                "openType": "4",
                "functionCode": "KDS_WebPageWithHead",
                "param": {
                    "webUrl": "http://guoyuan4.dengtacj.cn:55561/MineScanner/index.html#/pages/mineDimension/mineDimension?stockCode=0001300368&stockName=汇金股份",
                    "loginType": "1",
                    "jsCommands_onLoad": null
                }
            }
        }
    ],
    "link": [
        "ST易事特股票个股分析",
        "汇金股份股票财务状况如何"
    ],
    "push": "0",
    "type": "sl",
    "date": "20250825",
    "url": {
        "openSource": null,
        "openType": "4",
        "functionCode": "KDS_WebPageWithHead",
        "param": {
            "webUrl": "https://guoyuan4.mdengta.com/MineScanner/index.html",
            "loginType": "1",
            "jsCommands_onLoad": null
        }
    },
    "linkUrl": null,
    "createTime": "1756088948008"
  },
  
  {
    "no": "Os8VeEks4q6KQ5Yo",
    "entrance": "你关注的股票涨停啦，快来看看发送了什么~",
    "title": "Hi，发现你关注的股票今日涨停，已为你整理涨停解析，请查收~",
    "card": [
        {
            "sub": "华为（鸿蒙、鲸鸿动能）+数字人民币+区块链+AI应用+VR游戏",
            "name": "智度股份（000676）",
            "up": "1",
            "upData": "2.94%",
            "url": null
        },
        {
            "sub": "PCB（华为）+AI服务器+光模块+5G",
            "name": "方正科技（600601）",
            "up": "1",
            "upData": "1.27%",
            "url": null
        },
        {
            "sub": "业绩增长+游戏/英伟达+数字人+文心一言",
            "name": "顺网科技（300113）",
            "up": "0",
            "upData": "-0.66%",
            "url": null
        }
    ],
    "link": [
        "预测一下智度股份股票的表现",
        "方正科技股票业绩走势曲线"
    ],
    "push": "0",
    "type": "ztfx",
    "date": "20250825",
    "url": {
        "openSource": null,
        "openType": "4",
        "functionCode": "KDS_WebPageNoHead",
        "param": {
            "webUrl": "https://djyyztex.gyzq.com.cn:18080/hardenAnalyze/client/ztjx/index.html#/?GYIconColor=2&GYBackgroundColor=ffffff&GYOpacity=1",
            "loginType": "1",
            "jsCommands_onLoad": null,
            "dzhStockType": null,
            "stockName": null,
            "dzhStockCode": null
        }
    },
    "linkUrl": null,
    "createTime": "1756092060595"
  },
  
    // {
    //   type: 'tggd',
    //   createTime: "1753174980297",
    //   title: '你关注的[盛则辉、姚蕾、唐烨鹏、傅青云]老师发布了新观点，请查阅~',
    //   title1: '伊以同意停火导致油价大跌，能否波及油气股?',
    //   title2: '隔夜美股三大指数集体收涨，恒生指数涨0.67%，原油大跌9%；国内政策方面，《互联网平台企业涉税信息报送规定》公布，国家能源局数据显示5月发电装机容量同比增长18.8%，全国工商联呼吁优化汽车经销商返利政策:国际动态包括伊以同意停火导致油价大跌;今日A股关注智能驾驶、商业航天、能源金属及跨境支付等板块的持续性。',
    //   url: {
    //     "openSource": null,
    //     "openType": "3",
    //     "functionCode": "FN_SM_TGLive",
    //     "param": {
    //       "webUrl": {"startUPAdv":"11","funId":"0","url":"https://tgc.gyzq.com.cn/tgh5/view/detail/7920"},
    //         "loginType": "",
    //         "jsCommands_onLoad": null,
    //         "dzhStockType": null,
    //         "stockName": null,
    //         "dzhStockCode": null
    //     }
    // },
    //   link: ["热点板块分析", "大盘主力资金流向如何", "大盘估值分析"],
    // },
  
   

    
    {
        "no": "OLdHn4myZvACs57W",
        "entrance": "交易时间太忙？行情波动太快？股票持仓太多？智能条件单助您轻松应对",
        "title": "小元为你精选了适合当前阶段的投资百科为您推荐:交易时间太忙？行情波动太快？股票持仓太多？智能条件单助您轻松应对",
        "card": [
          {
            "sub": "https://saas0.yundzh.com/#/gyzq/liveBack/45355",
            "name": "https://hdzq.gyzq.com.cn:1443/activity/img/2025/jptj/etfbk15.png",
            "up": null,
            "upData": null,
            "url": null,
            "map": null
          }
        ],
        "link": [
          "大盘整体点评",
          "2025年国内GDP"
        ],
        "push": "0",
        "type": "jptjgstz",
        "date": "20250828",
        "url": {
            "openSource": null,
            "openType": "3",
            "functionCode": "KDS_WebPageWithHead",
            "param": {
              "webUrl": "https://hdzq.gyzq.com.cn:1443/activity/2025/wgjy/index.html#/wgjy/video?GYBackgroundColor=&GYOpacity=1&actCode=25jptj",
              "loginType": "1",
              "jsCommands_onLoad": null,
              "dzhStockType": null,
              "stockName": null,
              "dzhStockCode": null
            }
          },
        "linkUrl": null,
        "createTime": "1756373040045"
      },
  
    {
        "no": "OLdHn4myZvACs57W",
        "entrance": "",
        "title": "小元为你整理了专业投资者常用的分析方法今日推荐:《什么是市盈率》",
        "card": [
          {
            "sub": "https://saas0.yundzh.com/#/gyzq/liveBack/45355",
            "name": "https://hdzq.gyzq.com.cn:1443/activity/img/2025/jptj/etfbk15.png",
            "up": null,
            "upData": null,
            "url": null,
            "map": null
          }
        ],
        "link": [
          "大盘整体点评",
          "2025年国内GDP"
        ],
        "push": "0",
        "type": "jptjjjjs",
        "date": "20250828",
        "url": {
            "openSource": null,
            "openType": "3",
            "functionCode": "KDS_WebPageWithHead",
            "param": {
              "webUrl": "https://hdzq.gyzq.com.cn:1443/activity/2025/wgjy/index.html#/wgjy/video?GYBackgroundColor=&GYOpacity=1&actCode=25jptj",
              "loginType": "1",
              "jsCommands_onLoad": null,
              "dzhStockType": null,
              "stockName": null,
              "dzhStockCode": null
            }
          },
        "linkUrl": null,
        "createTime": "1756373040045"
      },

    {
      "no": "OLdHn4myZvACs57W",
      "entrance": "《到底什么是并购重组？》",
      "title": "投资第一步，从了解这些概念开始今天解锁:《到底什么是并购重组?》",
      "card": [
        {
          "sub": "https://saas0.yundzh.com/#/gyzq/liveBack/45355",
          "name": "https://hdzq.gyzq.com.cn:1443/activity/img/2025/jptj/etfbk15.png",
          "up": null,
          "upData": null,
          "url": null,
          "map": null
        }
      ],
      "link": [
        "大盘整体点评",
        "2025年国内GDP"
      ],
      "push": "0",
      "type": "jptjxsgn",
      "date": "20250828",
      "url": {
          "openSource": null,
          "openType": "3",
          "functionCode": "KDS_WebPageWithHead",
          "param": {
            "webUrl": "https://hdzq.gyzq.com.cn:1443/activity/2025/wgjy/index.html#/wgjy/video?GYBackgroundColor=&GYOpacity=1&actCode=25jptj",
            "loginType": "1",
            "jsCommands_onLoad": null,
            "dzhStockType": null,
            "stockName": null,
            "dzhStockCode": null
          }
        },
      "linkUrl": null,
      "createTime": "1756373040045"
    },
  
        {
      "no": "OLdHn4myZvACs57W",
      "entrance": "",
      "title": "今天看:股票的起源：一场跨越时空的财富游戏》",
      "card": [
        {
          "sub": "https://saas0.yundzh.com/#/gyzq/liveBack/45355",
          "name": "https://hdzq.gyzq.com.cn:1443/activity/img/2025/jptj/etfbk15.png",
          "up": null,
          "upData": null,
          "url": null,
          "map": null
        }
      ],
      "link": [
        "大盘整体点评",
        "2025年国内GDP"
      ],
      "push": "0",
      "type": "jptjxsrs",
      "date": "20250828",
      "url": {
          "openSource": null,
          "openType": "3",
          "functionCode": "KDS_WebPageWithHead",
          "param": {
            "webUrl": "https://hdzq.gyzq.com.cn:1443/activity/2025/wgjy/index.html#/wgjy/video?GYBackgroundColor=&GYOpacity=1&actCode=25jptj",
            "loginType": "1",
            "jsCommands_onLoad": null,
            "dzhStockType": null,
            "stockName": null,
            "dzhStockCode": null
          }
        },
      "linkUrl": null,
      "createTime": "1756373040045"
    },
    {
      "no": "OLdHn4myZvACs57W",
      "entrance": "为你准备了【新手必看】什么是养老基金,点击查看",
      "title": "投资第一步，从了解这些概念开始 今天解锁：《到底什么是并购重组？》",
      "card": [
        {
          "sub": "https://saas0.yundzh.com/#/gyzq/liveBack/45355",
          "name": "https://hdzq.gyzq.com.cn:1443/activity/img/2025/jptj/etfbk15.png",
          "up": null,
          "upData": null,
          "url": null,
          "map": null
        }
      ],
      "link": [
        "大盘整体点评",
        "2025年国内GDP"
      ],
      "push": "0",
      "type": "jptjXS",
      "date": "20250828",
      "url": {
          "openSource": null,
          "openType": "3",
          "functionCode": "KDS_WebPageWithHead",
          "param": {
            "webUrl": "https://hdzq.gyzq.com.cn:1443/activity/2025/wgjy/index.html#/wgjy/video?GYBackgroundColor=&GYOpacity=1&actCode=25jptj",
            "loginType": "1",
            "jsCommands_onLoad": null,
            "dzhStockType": null,
            "stockName": null,
            "dzhStockCode": null
          }
        },
      "linkUrl": null,
      "createTime": "1756373040045"
    },
   
  
    {
    "no": "EFGM9Jrtrz5hWIpy",
    "entrance": "《读懂上市公司报告系列:如何阅读财报》",
    "title": "随着经验增长，这些投资知识可能对你很有帮助为您推荐:《读懂上市公司报告系列:如何阅读财报》",
    "card": [
      {
        "sub": "https://saas0.yundzh.com/#/gyzq/liveBack/45355",
        "name": "https://hdzq.gyzq.com.cn:1443/activity/img/2025/jptj/etfbk15.png",
        "up": "什么是市盈率",
        "upData": null,
        "url": null,
        "map": null
      }
    ],
    "link": [
      "不同行业的财报分析重点有何区别？",
      "财务报表异常是指公司存在问题吗？"
    ],
    "push": "0",
    "type": "jptjjjjz",
    "date": "20250828",
    "url": {
      "openSource": null,
      "openType": "3",
      "functionCode": "KDS_WebPageWithHead",
      "param": {
        "webUrl": "https://hdzq.gyzq.com.cn:1443/activity/2025/wgjy/index.html#/wgjy/video?GYBackgroundColor=&GYOpacity=1&actCode=25jptj",
        "loginType": "1",
        "jsCommands_onLoad": null,
        "dzhStockType": null,
        "stockName": null,
        "dzhStockCode": null
      }
    },
    "linkUrl": null,
    "createTime": "1756365900045"
  },
  
    {
  "no": "Y4iLzsoB71PXwajc",
  "entrance": "",
  "title": "小元为你梳理了投资中不可不知的基础规则为您推荐:【上交所投教】热线问答:炒股一定要看公告!都是大家的血泪教训!",
  "card": [
    {
      "sub": "https://saas0.yundzh.com/#/gyzq/liveBack/45828",
      "name": "https://hdzq.gyzq.com.cn:1443/activity/img/2025/jptj/etfbk14.png",
      "up": "集合竞价投资失败?",
      "upData": null,
      "url": null,
      "map": null
    }
  ],
  "link": [
    "如何避免公告带来的投资风险？",
    "集合竞价时，如何进行技术面分析"
  ],
  "push": "0",
  "type": "jptjgsgz",
  "date": "20250901",
  "url": {
    "openSource": null,
    "openType": "3",
    "functionCode": "KDS_WebPageWithHead",
    "param": {
      "webUrl": "http://60.166.4.238:48081/wxfw/resource/activity/2025/wgjy/index.html#/wgjy/video?GYBackgroundColor\u003d\u0026GYOpacity\u003d1\u0026actCode\u003d25jptj",
      "loginType": "1",
      "jsCommands_onLoad": null,
      "dzhStockType": null,
      "stockName": null,
      "dzhStockCode": null
    }
  },
  "linkUrl": null,
  "createTime": "1756714860079"
},
{
  "no": "l9Mu9hkXvfeyac8d",
  "entrance": "为你准备了【ETF精选视频】踏准行业节奏，把握趋势脉搏—ETF投资心得1,点击查看",
  "title": "今日为你精选: 《踏准行业节奏，把握趋势脉搏—ETF投资心得1》",
  "card": [
      {
          "sub": "https://tjjd.gyzq.com.cn/m/tj/views/common/videoPlay.html?video_id=291",
          "name": "https://hdzq.gyzq.com.cn:1443/activity/img/2025/jptj/etfbk2.png",
          "up": "踏准行业节奏，把握趋势脉搏—ETF投资心得1",
          "upData": null,
          "url": null,
          "map": null,
          "list": null
      }
  ],
  "link": [
      "近3日资金持续流入的ETF",
      "沪深300估值分析"
  ],
  "push": "0",
  "type": "jptjetf",
  "date": "20250908",
  "url": {
      "openSource": null,
      "openType": "3",
      "functionCode": "KDS_WebPageWithHead",
      "param": {
          "loginType": "1",
          "jsCommands_onLoad": null,
          "dzhStockType": null,
          "stockName": null,
          "dzhStockCode": null
      }
  },
  "linkUrl": [
      {
          "name": "ETF百科视频列表",
          "url": null
      },
      {
          "name": "ETF全策略",
          "url": null
      }
  ],
  "createTime": "1757319840053"
},

{
  "no": "Y4iLzsoB71PXwajc",
  "entrance": "",
  "title": "随着经验增长，，这些投资和识可能对你很有帮助:《价值百料》",
  "card": [
    {
      "sub": "https://saas0.yundzh.com/#/gyzq/liveBack/45828",
      "name": "https://hdzq.gyzq.com.cn:1443/activity/img/2025/jptj/etfbk14.png",
      "up": "集合竞价投资失败?",
      "upData": null,
      "url": null,
      "map": null
    }
  ],
  "link": [
    "如何避免公告带来的投资风险？",
    "集合竞价时，如何进行技术面分析"
  ],
  "push": "0",
  "type": "jptjgsjz",
  "date": "20250901",
  "url": {
    "openSource": null,
    "openType": "3",
    "functionCode": "KDS_WebPageWithHead",
    "param": {
      "webUrl": "http://60.166.4.238:48081/wxfw/resource/activity/2025/wgjy/index.html#/wgjy/video?GYBackgroundColor\u003d\u0026GYOpacity\u003d1\u0026actCode\u003d25jptj",
      "loginType": "1",
      "jsCommands_onLoad": null,
      "dzhStockType": null,
      "stockName": null,
      "dzhStockCode": null
    }
  },
  "linkUrl": null,
  "createTime": "1756714860079"
},


{
  "no": "Y4iLzsoB71PXwajc",
  "entrance": "",
  "title": "投资第一步，从了解这些概念开始:《概念百科》",
  "card": [
    {
      "sub": "https://saas0.yundzh.com/#/gyzq/liveBack/45828",
      "name": "https://hdzq.gyzq.com.cn:1443/activity/img/2025/jptj/etfbk14.png",
      "up": "集合竞价投资失败?",
      "upData": null,
      "url": null,
      "map": null
    }
  ],
  "link": [
    "如何避免公告带来的投资风险？",
    "集合竞价时，如何进行技术面分析"
  ],
  "push": "0",
  "type": "jptjgsgn",
  "date": "20250901",
  "url": {
    "openSource": null,
    "openType": "3",
    "functionCode": "KDS_WebPageWithHead",
    "param": {
      "webUrl": "http://60.166.4.238:48081/wxfw/resource/activity/2025/wgjy/index.html#/wgjy/video?GYBackgroundColor\u003d\u0026GYOpacity\u003d1\u0026actCode\u003d25jptj",
      "loginType": "1",
      "jsCommands_onLoad": null,
      "dzhStockType": null,
      "stockName": null,
      "dzhStockCode": null
    }
  },
  "linkUrl": null,
  "createTime": "1756714860079"
},
    {
      type: 'blz',
      createTime: "1753174980297",
      title: ["前8个月已有181只公募基金清盘，同比增加44%", "紫金矿业高管表示，碳酸锂价格回调意料之中，预计还有下跌空间", "酒鬼酒上半年净利润同比下降41.23%"],
      link: ["XX股票的相关新闻", "XX股票的最新公告"],
    },
    {
      "no": "KIX3kFR94FMNb2qj",
      "entrance": "今日避雷指南已更新，有提及你关注的股票，点击围观~",
      "title": "你好，今日投资避雷针已更新~",
      "card": [
          {
              "sub": null,
              "name": "[\"①上周运输市场继续调整，多数航线运价下跌；\",\"②芯原股份VeriSilicon Limited等6名股东拟询价转让5%公司股份；\",\"③中信证券预计美国消费支出与私人投资增速或将继续面临下行压力。\"]",
              "up": null,
              "upData": null,
              "url": null
          }
      ],
      "link": [
          "芯原股份股票的散户数量有何变化",
          "华扬联众股票的相关新闻",
          "中信证券股票的最新公告"
      ],
      "push": "0",
      "type": "tzblz",
      "date": "20250825",
      "url": {
          "openSource": null,
          "openType": "4",
          "functionCode": "KDS_WebPageWithHead",
          "param": {
              "webUrl": "https://djyyzt.gyzq.com.cn:18080/news/detail?listType=2007&newsId=GY-2124284&count=1",
              "loginType": "1",
              "jsCommands_onLoad": null,
              "dzhStockType": null,
              "stockName": null,
              "dzhStockCode": null
          }
      },
      "linkUrl": null,
      "createTime": "1756091340261"
  },
    {
      type: 'ydzd',
      createTime: "1753174980297",
      month: 5,
      money: '5,420',
      upType: 0,
      up: '3.22',
      hushen: '300',
      hushen1: '1.80',
      num: [7, 3, 5],
      data: [{ title: '盈利冠军', title1: '国元证券（000728）', up: 0, money: '1,325', tips: '（占本月总盈利25.00%）' },
      { title: '亏损警示', title1: '长城汽车（601633）', up: 0, money: '728', tips: '（占本月总亏损49.20%）' }
      ],
      caozuo: {
        mairu: 3, maichu: 2, pingjun: 17, shenglv: '63.64', jielun: '您的持仓本周整体平稳，未出现显著波动'
      },
      link: ["XX股票的相关新闻", "XX股票的最新公告"],
    },
    {
      "no": "GGvCelNAcx9TgAPr",
      "entrance": "周末理财别错过，国债理财周末也能享收益哦~",
      "title": "周四买入国债理财，周末也能享收益哦~",
      "card": [
          {
              "sub": "资金实际占用1天，收益覆盖3天(周五+周末)",
              "name": "今日(周四)15:30前参与1天期国债逆回购，",
              "up": null,
              "upData": null,
              "url": null,
              "map": null
          }
      ],
      "link": [
          "国债理财和股票有什么区别",
          "国债理财产品和基金比哪个更稳"
      ],
      "push": "0",
      "type": "zsgzlc",
      "date": "20250826",
      "url": null,
      "linkUrl": [
          {
              "name": "国债理财",
              "url": {
                  "openSource": null,
                  "openType": "1",
                  "functionCode": "KDS_SM_GZLC",
                  "param": {
                      "webUrl": null,
                      "loginType": "0",
                      "jsCommands_onLoad": null,
                      "dzhStockType": null,
                      "stockName": null,
                      "dzhStockCode": null
                  }
              }
          }
      ],
      "createTime": "1756190340132"
  },
    {
      "no": "qPM9U0rsKhsSOSm2",
      "entrance": "今日午报新鲜出炉，请查收~",
      "title": "你好！这是今天为你准备的市场动态",
      "card": [
          {
              "sub": null,
              "name": "[\"①今日早盘市场虽然冲高回落，但三大指数延续涨势续创阶段新高，稀土永磁涨幅居前，算力股持续活跃，地产、白酒等展开反弹；\",\"②个股层面，今日早盘涨停数量为43家，封板率为75%，连板股数量为8家，园林股份6连板。\"]",
              "up": null,
              "upData": null,
              "url": null
          }
      ],
      "link": [
          "上证指数走势如何",
          "预测一下大盘走势"
      ],
      "push": "0",
      "type": "tzzwbwb",
      "date": "20250825",
      "url": {
          "openSource": null,
          "openType": "4",
          "functionCode": "KDS_WebPageWithHead",
          "param": {
              "webUrl": "https://djyyzt.gyzq.com.cn:18080/news/detail?listType=2007&newsId=GY-2124565&count=1",
              "loginType": "1",
              "jsCommands_onLoad": null,
              "dzhStockType": null,
              "stockName": null,
              "dzhStockCode": null
          }
      },
      "linkUrl": null,
      "createTime": "1756098000251"
  },
  {
    "no": "j0pN30btNumjPSFN",
    "entrance": "今日早报新鲜出炉，请查收~",
    "title": "你好！这是今天为你准备的市场动态",
    "card": [
        {
            "sub": null,
            "name": "[\"①国常会重磅部署！事关体育产业、大规模设备更新等\",\"②英伟达要求部分零部件供应商暂停生产H20芯片，外交部回应\",\"③鲍威尔暗示美联储或在9月降息，道指再创新高\",\"④中国智能算力规模增长将超40%\",\"⑤中国中铁：尖扎黄河特大桥施工事故原因正在调查中。\"]",
            "up": null,
            "upData": null,
            "url": null
        }
    ],
    "link": [
        "上证指数走势如何",
        "预测一下大盘走势"
    ],
    "push": "0",
    "type": "tzzwbzb",
    "date": "20250825",
    "url": {
        "openSource": null,
        "openType": "4",
        "functionCode": "KDS_WebPageWithHead",
        "param": {
            "webUrl": "https://djyyzt.gyzq.com.cn:18080/news/detail?listType=2007&newsId=GY-2124244&count=1",
            "loginType": "1",
            "jsCommands_onLoad": null,
            "dzhStockType": null,
            "stockName": null,
            "dzhStockCode": null
        }
    },
    "linkUrl": null,
    "createTime": "1756090440204"
  },
  {
    "no": "pUJfPH6gv0Ji95s4",
    "entrance": "今日每日收评新鲜出炉，请查收~",
    "title": "你好！这是今天为你准备的市场动态",
    "card": [
        {
            "sub": null,
            "name": "[\"①今日市场全天震荡走高，创业板涨超3%，沪指逼近3900点，两市成交额增至3.14万亿创下历史次高；\",\"②盘面上，稀土概念股全天领涨，包钢股份等个股涨停，算力硬件方向再度走强，中际旭创等多股续创历史新高。\"]",
            "up": null,
            "upData": null,
            "url": null
        }
    ],
    "link": [
        "上证指数走势如何",
        "预测一下大盘走势"
    ],
    "push": "0",
    "type": "tzzwbmrsp",
    "date": "20250825",
    "url": {
        "openSource": null,
        "openType": "4",
        "functionCode": "KDS_WebPageWithHead",
        "param": {
            "webUrl": "https://djyyzt.gyzq.com.cn:18080/news/detail?listType=2007&newsId=GY-2124898&count=1",
            "loginType": "1",
            "jsCommands_onLoad": null,
            "dzhStockType": null,
            "stockName": null,
            "dzhStockCode": null
        }
    },
    "linkUrl": null,
    "createTime": "1756115400409"
  },
    // {
    //   type: 'mrztqz',
    //   createTime: "1753174980297",
    //   title: ["连板股晋级率回升至53.8%，尽管最高标信隆健康止步9连板，但低位连板股实现高晋级率，明牌珠宝等3板以上个股全部实现晋级", "尽管算力、机器人等主线热点得到资金回流，但多以低位小市值品种补涨为主，对于一些涨幅过大的前期高人气品种仍应适当规避"],
    //   link: ["预测一下大盘走势", "目前大盘多少仓位比较合适"],
    // },

       {
      "no": "KIX3kFR94FMNb2qj",
      "title": "你好，明日主题前瞻已更新",
      "card": [
          {
              "sub": null,
              "name": "[\"①连板股晋级率回升至53.8%，尽管最高标信隆健康止步9连板，但低位连板股实现高晋级率，明牌珠宝等3板以上个股全部实现晋级；\",\"②尽管算力、机器人等主线热点得到资金回流，但多以低位小市值品种补涨为主，对于一些涨幅过大的前期高人气品种仍应适当规避；\"]",
              "up": null,
              "upData": null,
              "url": null
          }
      ],
      "link": [
          "预测一下大盘走势",
          "华扬联众股票的相关新闻",
          "目前大盘多少仓位比较合适"
      ],
      "push": "0",
      "type": "mrztqq",
      "date": "20250825",
      "url": {
            "openSource": null,
            "functionCode": "KDS_WebPageWithHead",
            "openType":"3",
                "param": {
                "loginType": "1",
                "webUrl": "http://60.166.4.238:18080/news/detail?listType=2007&newsId=XXX&count=1"
                }
            
      },
      "linkUrl": null,
      "createTime": "1756091340261"
  },
    // {
    //   type: 'jdfp',
    //   createTime: "1753174980297",
    //   title: ["D-Wave宣布新的量子计算突破，机构称我国量子计算产业发展潜力巨大", "广东:壮大银发经济市场规模培育银发经济潜力产业","全球巨头宣布下周举办该行业盛会,这类产品或迎来爆发期"],
    //   link: ["预测一下大盘走势", "目前大盘多少仓位比较合适"],
    // },
    {
      "no": "KIX3kFR94FMNb2qj",
      "entrance": "今日避雷指南已更新，有提及你关注的股票，点击围观~",
      "title": "小元带你回顾今日市场焦点:",
      "card": [
          {
              "sub": null,
              "name": "[\"①D-Wave宣布新的量子计算突破，机构称我国量子计算产业发展潜力巨大；\",\"②广东:壮大银发经济市场规模培育银发经济潜力产业；\",\"③全球巨头宣布下周举办该行业盛会,这类产品或迎来爆发期。\"]",
              "up": null,
              "upData": null,
              "url": null
          }
      ],
      "link": [
          "预测一下大盘走势",
          "中信证券股票的最新公告"
      ],
      "push": "0",
      "type": "jdpf",
      "date": "20250825",
      "url": {
        "openSource": null,
        "functionCode": "KDS_WebPageWithHead",
        "openType":"3",
            "param": {
            "loginType": "1",
            "webUrl": "http://60.166.4.238:18080/news/detail?listType=2007&newsId=XXX&count=1"
            }
        },
      "linkUrl": null,
      "createTime": "1756091340261"
  },
    {
      "no": "zZK43GgzzkAKHOf7",
      "entrance": "试试这个选股策略：明星战法-低估值高股息",
      "title": "小元带你了解这个选股方法：明星战法-低估值高股息",
      "card": [
          {
              "sub": "选股条件：市净率0-1 市盈率0-10 每股现金流大于0元/股 股息率大于4%",
              "name": "策略介绍：聚焦市盈率小于1，市盈率小于10且股息率＞4%的标的，优选公用事业、银行等防御板块，通过估值回归与股息复利抵御市场波动，历史回测熊市期超额收益显著，止损设盈利下滑或股息率跌破3%，适用于利率下行期的稳健配置，需警惕“价值陷阱”。",
              "up": null,
              "upData": null,
              "url": null
          }
      ],
      "link": [
          "市净率和市盈率是什么？",
          "如何使用市净率和市盈率选择股票"
      ],
      "push": "0",
      "type": "clxg",
      "date": "20250822",
      "url": {
          "openSource": null,
          "openType": "3",
          "functionCode": "KDS_WebPageWithHead",
          "param": {
              "webUrl": "https://guoyuan.mdengta.com/selectStockDetailNew.html?apiAction=getSearchES&fromMyStrategy=true&title=大师经典-格雷厄姆积极性投资策略&condition=18_小于3|11_小于50|14_大于90%|192_大于3%|89_小于50%",
              "loginType": "1",
              "jsCommands_onLoad": null
          }
      },
      "linkUrl": [
          {
              "name": "估值侦察机",
              "url": {
                  "openSource": null,
                  "openType": "3",
                  "functionCode": "KDS_WebPageWithHead",
                  "param": {
                      "webUrl": "https://guoyuan.mdengta.com/selectStockDetailNew.html?apiAction=getSearchES&fromMyStrategy=true&title=大师经典-格雷厄姆积极性投资策略&condition=18_小于3|11_小于50|14_大于90%|192_大于3%|89_小于50%",
                      "loginType": "1",
                      "jsCommands_onLoad": null
                  }
              }
          },
          {
              "name": "格雷厄姆积极性投资策略",
              "url": {
                  "openSource": null,
                  "openType": "3",
                  "functionCode": "KDS_WebPageWithHead",
                  "param": {
                      "webUrl": "https://guoyuan.mdengta.com/selectStockDetailNew.html?apiAction=getSearchES&fromMyStrategy=true&title=大师经典-格雷厄姆积极性投资策略&condition=18_小于3|11_小于50|14_大于90%|192_大于3%|89_小于50%",
                      "loginType": "1",
                      "jsCommands_onLoad": null
                  }
              }
          }
      ],
      "createTime": "1755845520302"
  },
  {
    type: 'srtx',
    url:'去领取链接'
  },
  {
    "no": "jPUqvzzd2IGeoXpw",
    "entrance": "节假日资金别闲置！国债理财享收益",
    "title": "假期来临，你的资金可以这样安排~",
    "card": [
        {
            "sub": "现在操作国债逆回购，计息天数将覆盖整个假期，实现“资金占用时间短，享受收益天数多”的效果",
            "url": null,
            "map": null
        }
    ],
    "link": [
        "国债理财和股票有什么区别",
        "国债理财产品和基金比哪个更稳"
    ],
    "push": "0",
    "type": "jjrgzlc",
    "date": "20250826",
    "url": null,
    "linkUrl": [
        {
            "name": "国债理财",
            "url": {
                "openSource": null,
                "openType": "1",
                "functionCode": "KDS_SM_GZLC",
                "param": {
                    "webUrl": null,
                    "loginType": "0",
                    "jsCommands_onLoad": null,
                    "dzhStockType": null,
                    "stockName": null,
                    "dzhStockCode": null
                }
            }
        }
    ],
    "createTime": "1756190580966"
  },

          {
              "no": "PIyWk1zVwxIT0mjZ",
              "entrance": "[刘虎成、张三]老师发布了新观点，请查收~",
              "title": "你关注的[刘虎成、张三]老师发布了新观点，请查阅~",
              "card": [
                {
                  "sub": "看调整级别有多大，看3B的落点",
                  "name": "风控为主，等待更大级别3B中期级别调整结束后方可进场。",
                  "up": "https://tgc.gyzq.com.cn/group0/M00/1A/BB/wKgAZWc9oByAb5G7AAGbbMAYXmw869.png",
                  "upData": "1167",
                  "url": {
                    "openSource": null,
                    "openType": "2",
                    "functionCode": "FN_SM_TGLive",
                    "param": {
                      "webUrl": "{\"startUPAdv\":\"11\",\"funId\":\"0\",\"url\":\"https://tgc.gyzq.com.cn/tgh5/view/detail/T-7793\"}",
                      "loginType": null,
                      "jsCommands_onLoad": null,
                      "dzhStockType": null,
                      "stockName": null,
                      "dzhStockCode": null
                    }
                  },
                  "map": null
                }
              ],
              "link": [
                "热点板块分析",
                "大盘主力资金流向",
                "大盘估值分析"
              ],
              "push": "0",
              "type": "tggd",
              "date": "20250827",
              "url": {
                  "openSource": null,
                  "openType": "2",
                  "functionCode": "FN_SM_TGLive",
                  "param": {
                      "webUrl": "{\"startUPAdv\":\"11\",\"funId\":\"0\",\"url\":\"https://tgc.gyzq.com.cn/tgh5/view/detail/7793\"}",
                      "loginType": "",
                      "jsCommands_onLoad": null,
                      "dzhStockType": null,
                      "stockName": null,
                      "dzhStockCode": null
                  },
              },
              "linkUrl": null,
              "createTime": "1756273020218"
          },
         
          {
            "no": "bOGMoXju31k0B3k3",
            "entrance": "一季报更新啦，点击查看",
            "title": "一季报业绩快报已发布，涵盖营收、净利润等数据，方便你了解市场整体业绩表现",
            "card": [    {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "603322",
                  "mgsy": "0.31",
                  "jlrtb": "125.77",
                  "table": "净利润翻倍",
                  "gpmc": "超讯通信",
                  "ggrq": "04.26"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "600958",
                  "mgsy": "0.16",
                  "jlrtb": "62.08",
                  "table": "净利润大增",
                  "gpmc": "东方证券",
                  "ggrq": "04.14"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "603101",
                  "mgsy": "0.11420000000000001",
                  "jlrtb": "42.14",
                  "table": "净利润大增",
                  "gpmc": "汇嘉时代",
                  "ggrq": "04.11"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "000728",
                  "mgsy": "0.15",
                  "jlrtb": "38.4",
                  "table": "净利润大增",
                  "gpmc": "国元证券",
                  "ggrq": "04.11"
                }
              }
            ],
            "link": [    "超讯通信股票最新一季报解读",
              "历史上有类似业绩超预期后股价如何表现？"
            ],
            "push": "0",
            "type": "jbyjb",
            "date": "202509",
            "url": {
              "openSource": null,
              "openType": "3",
              "functionCode": "KDS_WebPageWithHead",
              "param": {
                "webUrl": "https://gyzqhz.upoem1.com/yjbx/yjkb",
                "loginType": "0",
                "jsCommands_onLoad": null,
                "dzhStockType": null,
                "stockName": null,
                "dzhStockCode": null
              }
            },
            "linkUrl": null,
            "createTime": "1756780380828"
          },
          {
            "no": "ybmqVgtxUDvh3ruR",
            "entrance": "业绩预告更新啦，点击查看",
            "title": "业绩预告年报已更新，包含业绩增长、扭亏、预减等方向，帮助您了解搁公司全年业绩预期",
            "card": [
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "002636",
                  "yglx": "预盈",
                  "yqjlbd": "-7.08%~7.22%",
                  "table": "利好",
                  "gpmc": "金安国纪",
                  "ggrq": "08.14"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "603501",
                  "yglx": "略增",
                  "yqjlbd": "39.43%~49.67%",
                  "table": "利好",
                  "gpmc": "豪威集团",
                  "ggrq": "08.05"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "688033",
                  "yglx": "略增",
                  "yqjlbd": "51.30%~61.44%",
                  "table": "利好",
                  "gpmc": "天宜新材",
                  "ggrq": "08.02"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "000656",
                  "yglx": "续亏",
                  "yqjlbd": "-97.91%~-97.91%",
                  "table": "利空",
                  "gpmc": "*ST金科",
                  "ggrq": "08.30"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "601058",
                  "yglx": "略减",
                  "yqjlbd": "-15.00%~-15.00%",
                  "table": "利空",
                  "gpmc": "赛轮轮胎",
                  "ggrq": "08.19"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "002660",
                  "yglx": "首亏",
                  "yqjlbd": "-169.59%~-151.44%",
                  "table": "利空",
                  "gpmc": "茂硕电源",
                  "ggrq": "08.19"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "300746",
                  "yglx": "大幅预增",
                  "yqjlbd": "303.20%~343.52%",
                  "table": "大幅预增",
                  "gpmc": "汉嘉设计",
                  "ggrq": "08.14"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "688696",
                  "yglx": "大幅预增",
                  "yqjlbd": "2062.33%~2062.33%",
                  "table": "大幅预增",
                  "gpmc": "极米科技",
                  "ggrq": "07.31"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "688511",
                  "yglx": "大幅预增",
                  "yqjlbd": "2064.85%~2064.85%",
                  "table": "大幅预增",
                  "gpmc": "*ST天微",
                  "ggrq": "07.30"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "600292",
                  "yglx": "大幅预减",
                  "yqjlbd": "-70.00%~-70.00%",
                  "table": "大幅预减",
                  "gpmc": "远达环保",
                  "ggrq": "08.19"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "688378",
                  "yglx": "大幅预减",
                  "yqjlbd": "-72.77%~-68.41%",
                  "table": "大幅预减",
                  "gpmc": "奥来德",
                  "ggrq": "08.14"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "605008",
                  "yglx": "大幅预减",
                  "yqjlbd": "-98.55%~-97.93%",
                  "table": "大幅预减",
                  "gpmc": "长鸿高科",
                  "ggrq": "08.08"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "688288",
                  "yglx": "扭亏",
                  "yqjlbd": "281.16%~281.16%",
                  "table": "扭亏",
                  "gpmc": "鸿泉物联",
                  "ggrq": "07.22"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "688321",
                  "yglx": "扭亏",
                  "yqjlbd": "173.00%~173.00%",
                  "table": "扭亏",
                  "gpmc": "微芯生物",
                  "ggrq": "07.18"
                }
              },
              {
                "sub": null,
                "name": null,
                "up": null,
                "upData": null,
                "url": null,
                "map": {
                  "gpdm": "603106",
                  "yglx": "扭亏",
                  "yqjlbd": "136.83%~144.20%",
                  "table": "扭亏",
                  "gpmc": "恒银科技",
                  "ggrq": "07.17"
                }
              }
            ],
            "link": [
              "金安国纪股票最新中报解读",
              "历史上有类似业绩超预期后股价如何表现？"
            ],
            "push": "0",
            "type": "jbnb",
            "date": "202509",
            "url": {
              "openSource": "TRADE_H5",
              "openType": "3",
              "functionCode": "KDS_WebPageWithHead",
              "param": {
                "webUrl": "https://gyzqhz.upoem1.com/yjbx/yjyg",
                "loginType": "3",
                "jsCommands_onLoad": null,
                "dzhStockType": null,
                "stockName": null,
                "dzhStockCode": null
              }
            },
            "linkUrl": null,
            "createTime": "1756781941128"
          }
          ,
        //   {
        //     "no": "qVGx0JSGzn2LSvFY",
        //     "entrance": "业绩预告更新啦，点击查看",
        //     "title": "业绩预告年报已更新，包含业绩增长、扭亏、预减等方向，帮助您了解搁公司全年业绩预期",
        //     "card": [    {
        //         "sub": null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "002636",
        //           "yglx": "预盈",
        //           "yqjlbd": "-7.08%~7.22%",
        //           "table": "利好",
        //           "gpmc": "金安国纪",
        //           "ggrq": "08.14"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "603501",
        //           "yglx": "略增",
        //           "yqjlbd": "39.43%~49.67%",
        //           "table": "利好",
        //           "gpmc": "豪威集团",
        //           "ggrq": "08.05"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "688033",
        //           "yglx": "略增",
        //           "yqjlbd": "51.30%~61.44%",
        //           "table": "利好",
        //           "gpmc": "天宜新材",
        //           "ggrq": "08.02"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "000656",
        //           "yglx": "续亏",
        //           "yqjlbd": "-97.91%~-97.91%",
        //           "table": "利空",
        //           "gpmc": "*ST金科",
        //           "ggrq": "08.30"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "601058",
        //           "yglx": "略减",
        //           "yqjlbd": "-15.00%~-15.00%",
        //           "table": "利空",
        //           "gpmc": "赛轮轮胎",
        //           "ggrq": "08.19"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "002660",
        //           "yglx": "首亏",
        //           "yqjlbd": "-169.59%~-151.44%",
        //           "table": "利空",
        //           "gpmc": "茂硕电源",
        //           "ggrq": "08.19"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "300746",
        //           "yglx": "大幅预增",
        //           "yqjlbd": "303.20%~343.52%",
        //           "table": "大幅预增",
        //           "gpmc": "汉嘉设计",
        //           "ggrq": "08.14"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "688696",
        //           "yglx": "大幅预增",
        //           "yqjlbd": "2062.33%~2062.33%",
        //           "table": "大幅预增",
        //           "gpmc": "极米科技",
        //           "ggrq": "07.31"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "688511",
        //           "yglx": "大幅预增",
        //           "yqjlbd": "2064.85%~2064.85%",
        //           "table": "大幅预增",
        //           "gpmc": "*ST天微",
        //           "ggrq": "07.30"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "600292",
        //           "yglx": "大幅预减",
        //           "yqjlbd": "-70.00%~-70.00%",
        //           "table": "大幅预减",
        //           "gpmc": "远达环保",
        //           "ggrq": "08.19"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "688378",
        //           "yglx": "大幅预减",
        //           "yqjlbd": "-72.77%~-68.41%",
        //           "table": "大幅预减",
        //           "gpmc": "奥来德",
        //           "ggrq": "08.14"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "605008",
        //           "yglx": "大幅预减",
        //           "yqjlbd": "-98.55%~-97.93%",
        //           "table": "大幅预减",
        //           "gpmc": "长鸿高科",
        //           "ggrq": "08.08"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "688288",
        //           "yglx": "扭亏",
        //           "yqjlbd": "281.16%~281.16%",
        //           "table": "扭亏",
        //           "gpmc": "鸿泉物联",
        //           "ggrq": "07.22"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "688321",
        //           "yglx": "扭亏",
        //           "yqjlbd": "173.00%~173.00%",
        //           "table": "扭亏",
        //           "gpmc": "微芯生物",
        //           "ggrq": "07.18"
        //         }
        //       },
        //       {
        //         "sub":  null,
        //         "name":  null,
        //         "up":  null,
        //         "upData":  null,
        //         "url":  null,
        //         "map": {
        //           "gpdm": "603106",
        //           "yglx": "扭亏",
        //           "yqjlbd": "136.83%~144.20%",
        //           "table": "扭亏",
        //           "gpmc": "恒银科技",
        //           "ggrq": "07.17"
        //         }
        //       }
        //     ],
        //     "link": [    "金安国纪股票最新中报解读",
        //       "历史上有类似业绩超预期后股价如何表现？"
        //     ],
        //     "push": "0",
        //     "type": "jbnb",
        //     "date": "202509",
        //     "url": {
        //         "openSource": 'TRADE_H5',
        //         "openType": "3",
        //         "functionCode": "KDS_WebPageWithHead",
        //         "param": {
        //         "webUrl": "https://gyzqhz.upoem1.com/yjbx/yjkb"
        //         }
        //         },
        //     "linkUrl":  null,
        //     "createTime": "1756780260405"
        //   }
          
            
  ];
  // 续盈
  export default topLit;
  